import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import { RootViews, SignInViews, SystemViews, PreOriginationViews, PostOriginationViews, CollectionViews, SettingViews, FilterViews } from '@/router/config'
import { Cache, Tool, Popup } from '@/util/index'
import version from '@/../version.json'

Vue.use(VueRouter)
Vue.use(store)

const tool = new Tool()
const cache = new Cache()
const popup = new Popup()
const routes = [
  RootViews,
  SignInViews,
  SystemViews,
  PreOriginationViews,
  PostOriginationViews,
  CollectionViews,
  SettingViews,
  FilterViews
]

const router = new VueRouter({ routes })
/* 路由拦截 */
router.beforeEach((to, from, next) => {
  // 这里去判断缓存(也就是版本有没有更新)
  const currentVersion = version.version
  const localVersion = localStorage.getItem('version')
  if (localVersion !== currentVersion || tool.isEmpty(localVersion)) {
    popup.popupForInfo('New version is detected',
      null,
      function () {
        localStorage.clear()
        localStorage.setItem('version', currentVersion)
        window.location.reload()
      })
  } else {
    localStorage.setItem('version', currentVersion)
  }
  window._axiosPromiseArr.forEach((ele, index) => {
    ele.cancel()
    delete window._axiosPromiseArr[index]
  })
  const _axiosPromiseArrLength = window._axiosPromiseArr.filter(d => d).length
  window._requestCount = _axiosPromiseArrLength
  const url = window.location.href
  const querys = url.substring(url.indexOf('?') + 1).split('&')
  for (let i = 0; i < querys.length; i++) {
    const temp = querys[i].split('=')
    if (temp.length >= 2) {
      const accessToken = temp[1]
      cache.setAccessToken(accessToken)
    }
  }
  if (tool.isEmpty(cache.getAccessToken()) && to.path !== '/sign-in') {
    next('/sign-in')
  }
  if (to.matched.length === 0) {
    next('/404')
  } else {
    to.path === '/sign-in' && cache.removeAccessToken()
    next()
  }
})
// push
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch((err) => err)
}

// replace
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => err)
}
export default router
